import React from 'react'
import Layout from '../components/layout/Layout'
import { UseCasesView } from '../components/pages/usecases'

const CodePage: React.FC = () => {
  return (
    <Layout
      title="Code Samples"
      description="Runnable multi-agent code samples from Designing Multi-Agent Systems — build agents from scratch, orchestrate them, and evaluate the result."
    >
      <div className="mb-6"></div>
      <UseCasesView isComponent={false} />
    </Layout>
  )
}

export default CodePage